var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "editarInfoStreamax",
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c("v-card", { attrs: { id: "cardDivTV" } }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "cardnew", attrs: { align: "center" } },
            [
              _c("br"),
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.validForm,
                            callback: function($$v) {
                              _vm.validForm = $$v
                            },
                            expression: "validForm"
                          }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "div",
                                { attrs: { align: "left" } },
                                [
                                  _c("v-flex", { attrs: { md12: "" } }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "h2_title",
                                        staticStyle: {
                                          "margin-top": "12px !important"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.esEdicion
                                                ? "Editar Comunication Streamax"
                                                : "Ver Detalle Comunication Module Streamax"
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c("br"),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("Module 1")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.serverTypeModule1
                                              .label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.serverTypeModule1
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.serverTypeModule1,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.serverTypeModule1.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.networkTypeModule1
                                              .label,
                                          items:
                                            _vm.formFields.networkTypeModule1
                                              .items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedNetworkTypeModule1,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.networkTypeModule1
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.networkTypeModule1,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.networkTypeModule1.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("Dialing Parameter")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm7: "",
                                        md7: "",
                                        lg7: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.apnModule1.label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.apnModule1.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.apnModule1,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.apnModule1.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm7: "",
                                        md7: "",
                                        lg7: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.usernameModule1
                                              .label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.usernameModule1
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.usernameModule1,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.usernameModule1.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm7: "",
                                        md7: "",
                                        lg7: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.passwordModule1
                                              .label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.passwordModule1
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.passwordModule1,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.passwordModule1.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm7: "",
                                        md7: "",
                                        lg7: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.numberModule1.label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.numberModule1.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.numberModule1,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.numberModule1.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm7: "",
                                        md7: "",
                                        lg7: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.certificationModule1
                                              .label,
                                          items:
                                            _vm.formFields.certificationModule1
                                              .items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value:
                                            _vm.selectedCertificationModule1,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.certificationModule1
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields
                                                .certificationModule1,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.certificationModule1.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("Module 2")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.serverTypeModule2
                                              .label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.serverTypeModule2
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.serverTypeModule2,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.serverTypeModule2.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.networkTypeModule2
                                              .label,
                                          items:
                                            _vm.formFields.networkTypeModule2
                                              .items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedNetworkTypeModule2,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.networkTypeModule2
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.networkTypeModule2,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.networkTypeModule2.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("Dialing Parameter")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm7: "",
                                        md7: "",
                                        lg7: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.apnModule2.label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.apnModule2.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.apnModule2,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.apnModule2.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm7: "",
                                        md7: "",
                                        lg7: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.usernameModule2
                                              .label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.usernameModule2
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.usernameModule2,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.usernameModule2.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm7: "",
                                        md7: "",
                                        lg7: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.passwordModule2
                                              .label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.passwordModule2
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.passwordModule2,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.passwordModule2.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm7: "",
                                        md7: "",
                                        lg7: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.numberModule2.label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.numberModule2.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.numberModule2,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.numberModule2.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm7: "",
                                        md7: "",
                                        lg7: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.certificationModule2
                                              .label,
                                          items:
                                            _vm.formFields.certificationModule2
                                              .items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value:
                                            _vm.selectedCertificationModule2,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.certificationModule2
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields
                                                .certificationModule2,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.certificationModule2.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm4: "",
                                        md4: "",
                                        lg4: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("Active Mode")
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm4: "",
                                        md4: "",
                                        lg4: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.activeMode.label,
                                          items:
                                            _vm.formFields.activeMode.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedActiveMode,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.activeMode.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.activeMode,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.activeMode.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.number1.label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value: _vm.formFields.number1.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.number1,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.number1.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.number2.label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value: _vm.formFields.number2.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.number2,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.number2.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.number3.label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value: _vm.formFields.number3.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.number3,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.number3.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }